// Polyfill for Node.js process object
if (typeof global === 'undefined') {
  window.global = window;
}

if (typeof process === 'undefined') {
  window.process = {
    env: {},
    hrtime: function(time) {
      const now = performance.now();
      if (time) {
        const diff = now - time[0] * 1000 - time[1] / 1e6;
        return [Math.floor(diff / 1000), (diff % 1000) * 1e6];
      }
      return [Math.floor(now / 1000), (now % 1000) * 1e6];
    }
  };
}